import React from "react";
// Initialize theme exports before Vite's split MUI component dependencies.
import "@mui/material/styles";
import "./index.css";
import "./modules/i18n/configureYupLocale";
import { appI18nReady } from "./modules/i18n/i18n";
import { configureMobx } from "./modules/app/services";
import { initLoggers } from "./common/logger";
import "@fontsource/nunito-sans/";
import "@fontsource/inter/variable.css";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import "leaflet/dist/leaflet.css";

// init
configureMobx();
initLoggers();

if (!!import.meta.env.VITE_SENTRY_DSN && import.meta.env.VITE_PRIVATE_EDITION !== "1") {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [new BrowserTracing()],
        environment: import.meta.env.VITE_ENVIRONMENT,
        release: import.meta.env.VITE_VERSION,
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });
}

const container = document.getElementById("root");
const root = createRoot(container);

const renderApp = async () => {
    try {
        await appI18nReady;
    } catch (error) {
        console.error("Failed to load the preferred language; falling back to English.", error);
    }

    const { default: App } = await import("./modules/app/App");
    root.render(<App />);
};

void renderApp();
